export const SCREENER_FILTERS = {
    descriptive: [
      {
        name: "Market Cap (More Than)",
        label: "marketCapMoreThan",
        items: ["10000000", "100000000", "1000000000"],
      },
      {
        name: "Industry",
        label: "industry",
        items: ["Software", "Airlines", "Banks"],
      },
      {
        name: "Price More Than",
        label: "priceMoreThan",
        items: ["100", "1000", "10000"]
      },
      {
        name: "Volume More Than",
        label: "volumeMoreThan",
        items: ["100", "1000", "10000", "100000", "1000000", "1000000", "100000000", "1000000000"]
      },
      {
        name: "Country",
        label: "Country",
        items: ["US", "UK", "CA"]
      }
    ],
    // fundamental: [
    //   {
    //       name: "Price/Cash",
    //       label: "priceCash",
    //       items: ["Under 1", "Under 2", "Under 3"],
    //   }
    // ]
  };